import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../../styles/datepicker.css';
import { es } from 'date-fns/locale';

/**
 * Componente para desplegar un calendario para elegir las fechas
 * @param {fechaSeleccionada} param0 variable donde se guardará la fecha en formato "dd/mm/yyyy" 
 * @param {setFechaSeleccionada} param1 funcion para setear el valor de la fecha seleccionada
 * @param {fechasPermitidas} param2 vector de fechas tipo DATE el cual se podrá seleccionar en el calendario. 
 * @param {value} param3 mandar la variable en el cual se guarda la fecha seleccionada para poder pintar la fecha en el calendario
 * @returns  
 */
const SelectorDeFecha = ({ fechaSeleccionada, setFechaSeleccionada, fechasPermitidas}) => {

    const formatearFecha = (fecha) => {
        if (!(fecha instanceof Date) || isNaN(fecha)) return '';
        const dia = String(fecha.getDate()).padStart(2, '0');
        const mes = String(fecha.getMonth() + 1).padStart(2, '0');
        const anio = fecha.getFullYear();
        return `${dia}/${mes}/${anio}`;
    };

    const parsearFecha = (fechaStr) => {
        if (!fechaStr) return null;
        const [dia, mes, anio] = fechaStr.split('/');
        return new Date(parseInt(anio), parseInt(mes) - 1, parseInt(dia));
    };

    return (
        <DatePicker
            selected={parsearFecha(fechaSeleccionada)}
            onChange={(date)=>{
                const fecha = formatearFecha(date);
                setFechaSeleccionada(fecha);
            }}
            includeDates={fechasPermitidas}
            dateFormat="dd/MM/yyyy"
            placeholderText="Seleccione una fecha válida"
            className="form-control"
            calendarClassName="calendar-styled"
            locale={es}
        />
    )
}

export default SelectorDeFecha;